import { render } from "./ScDataTableSelected.vue?vue&type=template&id=604473a2"
import script from "./ScDataTableSelected.vue?vue&type=script&lang=js"
export * from "./ScDataTableSelected.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/bezbedno/admin/static/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"js/Components/DataTable2/ScDataTableSelected.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "604473a2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('604473a2', __exports__)) {
    console.log('reload')
    api.reload('604473a2', __exports__)
  }
  
  module.hot.accept("./ScDataTableSelected.vue?vue&type=template&id=604473a2", () => {
    console.log('re-render')
    api.rerender('604473a2', render)
  })

}


export default __exports__